import Heading from "../../../components/heading/heading.component";
import { LinkStyled } from "../privacy-notice/PrivacyNotice.styles";
import { SupportCenterContainer } from "./SupportCenter.styles";

const SupportCenter = () => {
  return (
    <SupportCenterContainer className="App login_page">
      <Heading previusPage={"FAQS"} />
      <p>
        <h3>Account and Cash Balances</h3>
      </p>
      <p>
        <strong>
          1. How do I deposit funds into my MusicBull trading account?
        </strong>
      </p>
      <p>
        Answer: To deposit funds, log in to your account and navigate to the
        &quot;Wallet&quot; or &quot;Funds&quot; section. Select
        &quot;Deposit,&quot; choose your preferred payment method (e.g. credit
        card, PayPal), enter the amount, and follow the on-screen instructions
        to complete the transaction.
      </p>
      <p>
        <strong>2. What payment methods are accepted for deposits?</strong>
      </p>
      <p>
        Answer: MusicBull accepts various payment methods, like credit/debit
        cards, and e-wallets like PayPal. Check the &quot;Deposit Funds&quot;
        page for the full list of available options.
      </p>
      <p>
        <strong>
          3. Are there any fees associated with deposits and withdrawals?
        </strong>
      </p>
      <p>
        Answer: Deposits are generally free of charge, but some payment
        providers may impose their own fees. Withdrawal fees may apply depending
        on the withdrawal method. Please refer to our{" "}
        <LinkStyled href="https://musicbull.com/auction-exchange-fees/">Fees Schedule&nbsp;
        </LinkStyled>{" "}
        for detailed information. &nbsp;
      </p>
      <p>
        <strong>
          4. How long does it take for my deposit to appear in my account?
        </strong>
      </p>
      <p>
        Answer: Deposits via credit/debit card and e-wallets typically take a
        few minutes. Bank transfers may take a few business days to process.
        You&apos;ll receive a notification once the funds are available in your
        account.
      </p>
      <p>
        <strong>5. How do I withdraw funds from my MusicBull account?</strong>
      </p>
      <p>
        Answer: To withdraw funds, log to the platform and click on the
        &ldquo;Wallet&rdquo; icon (located on the top right), choose
        &ldquo;Transaction History&rdquo; and then select &nbsp;
        &quot;Withdraw&rdquo;. Choose the amount you wish to withdraw, and enter
        the email address associated with your PayPal account, and follow the
        instructions&nbsp;
      </p>
      <p>
        <strong>6. Why is my withdrawal pending or delayed?</strong>
      </p>
      <p>
        Answer: Withdrawals may be pending due to processing times, verification
        requirements, or security checks. If it&apos;s been more than 5 business
        days, please contact customer support for assistance.
      </p>
      <p>
        <strong>
          7. Can I transfer funds between my MusicBull account and other users?
        </strong>
      </p>
      <p>
        Answer: Direct transfers between user accounts are not supported. All
        transactions must go through the standard deposit and withdrawal
        processes.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Trading Orders</h3>
      </p>
      <p>
        <strong>
          8. How do I place a buy or sell order in the secondary market?
        </strong>
      </p>
      <p>
        Answer: Navigate to the &quot;Trading Board,&quot; find the symbol you
        wish to trade, and click on &quot;Buy&quot; or &quot;Sell.&quot; Enter
        the number of units and your desired price. You can choose between
        market orders and limit orders.
      </p>
      <p>
        <strong>
          9. What is the difference between a market order and a limit order?
        </strong>
      </p>
      <p>
        Answer: Market Order executes immediately at the best available current
        price. Limit Order executes only at a specified price or better. If the
        market doesn&apos;t reach your price, the order remains pending.
      </p>
      <p>
        <strong>10. Where can I view my pending orders?&nbsp;</strong>
      </p>
      <p>
        Answer: Go to &quot;My Portfolio&quot; and select the &quot;Pending
        Orders&quot; tab. Here you&apos;ll see all your open buy and sell
        orders, including their status.
      </p>
      <p>
        <strong>11. How can I cancel a pending order?</strong>
      </p>
      <p>
        Answer: In the &quot;Pending Orders&quot; section, find the order you
        wish to cancel and click on the &quot;Cancel&quot; button next to it.
        Please note that market orders as well as auction bids cannot be
        canceled once submitted.
      </p>
      <p>
        <strong>12. Why was my order partially filled?</strong>
      </p>
      <p>
        Answer: Partial fills occur when there&apos;s not enough liquidity at
        your specified price to fill the entire order. The remaining units will
        stay pending until more matching orders become available or until you
        cancel the order.
      </p>
      <p>
        <strong>
          13. What happens if my limit order is not executed?&nbsp;
        </strong>
      </p>
      <p>
        Answer: If the market price doesn&apos;t reach your limit price, the
        order remains open until it expires or you cancel it. You can adjust or
        cancel the order at any time before execution.
      </p>
      <p>
        <strong>14. Can I modify a pending order?</strong>
      </p>
      <p>
        Answer: You can cancel orders placed in the secondary market and place a
        new order instead. Auction bids can&rsquo;t be canceled or modified.
        &nbsp;
      </p>
      <p>
        <strong>15. What are the trading hours on MusicBull?</strong>
      </p>
      <p>
        Answer: The platform operates 24/7, but liquidity may vary during
        off-peak hours. Scheduled maintenance or updates may temporarily affect
        trading availability.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Cash Management</h3>
      </p>
      <p>
        <strong>16. How is my cash balance calculated?</strong>
      </p>
      <p>
        Answer: Your cash balance includes deposited funds, realized
        profits/losses from closed trades, and any received royalties. The Cash
        balance consists of Available Cash and Restricted Cash (cash that is
        used to support your pending orders).&nbsp;
      </p>
      <p>
        <strong>
          17. Why is a portion of my cash balance &ldquo;restricted&rdquo;?
        </strong>
      </p>
      <p>
        Answer: Funds may be on hold due to pending buy orders. Once the pending
        transactions are settled, any remaining balance will be released back to
        your Available Cash.
      </p>
      <p>
        <strong>18. How can I view my transactions history?</strong>
      </p>
      <p>
        Answer: Go to your &quot;Account&quot; section and select
        &quot;Transactions History.&quot; You can filter transactions by Order,
        Type and Status.
      </p>
      <p>
        <strong>19. How are royalties credited to my account?</strong>
      </p>
      <p>
        Answer: Royalties are credited to your cash balance on the cut off date
        (scheduled distribution dates, usually quarterly or semi-annually). You
        can view the details in the &quot;Transactions History&quot; section of
        your account.
      </p>
      <p>
        <strong>20. Can I use my royalties to place new trades?</strong>
      </p>
      <p>
        Answer: Yes, once royalties are credited to your cash balance, they can
        be used for trading, held in your account, or withdrawn per your
        preference.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Account Verification and Compliance</h3>
      </p>
      <p>
        <strong>21. Why do I need to complete KYC verification?</strong>
      </p>
      <p>
        Answer: KYC verification is required to comply with regulatory
        standards, prevent fraud, and ensure the security of all users. It
        involves verifying your identity with official documents.
      </p>
      <p>
        <strong>22. What documents are required for KYC verification?</strong>
      </p>
      <p>
        Answer: Typically, you&apos;ll need to provide a government-issued ID
        (passport, driver&apos;s license), proof of address (utility bill, bank
        statement), and possibly a selfie or video verification.
      </p>
      <p>
        <strong>23. How long does the verification process take?</strong>
      </p>
      <p>
        Answer: Verification usually takes up to 3 business days. You&apos;ll
        receive a notification once your account is verified or if additional
        information is needed.
      </p>
      <p>
        <strong>24. Can I trade before completing verification?</strong>
      </p>
      <p>
        Answer: Yes you can deposit and trade up to $600 without completing your
        &nbsp;KYC verification, higher Deposits, withdrawals, and trading are
        restricted to prevent fraudulent activities.&nbsp;
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Technical Issues and Troubleshooting</h3>
      </p>
      <p>
        <strong>
          25. What should I do if I encounter an error while placing an
          order?&nbsp;
        </strong>
      </p>
      <p>
        Answer: First, check your internet connection and ensure all required
        fields are correctly filled. If the problem persists, take a screenshot
        of the error message and contact customer support for assistance through
        the online form located at{" "}
        <LinkStyled href="https://musicbull.com/contact-us/">
          https://musicbull.com/contact-us/
        </LinkStyled>{" "}
        or email us directly at Contact@MusicBull.com
      </p>
      <p>
        <strong>26. I forgot my password. How can I reset it?&nbsp;</strong>
      </p>
      <p>
        Answer: Click on the &quot;Forgot Password&quot; link on the login page.
        Enter your registered email address, and we&apos;ll send you
        instructions to reset your password securely.
      </p>
      <p>
        <strong>
          27. What if I suspect unauthorize`d activity on my account?
        </strong>
      </p>
      <p>
        Answer: Immediately change your password and enable two-factor
        authentication (2FA) if not already active. Contact customer support to
        report the issue and for further assistance.
      </p>
      <p>
        <strong>28. How do I enable two-factor authentication (2FA)?</strong>
      </p>
      <p>
        Answer: 2FA is enabled automatically and can be turned off in the
        &nbsp;&quot;Account&quot; and selecting &ldquo;Account Settings&rdquo;
        and then &quot;Two-factor authentication&quot;. section requires using
        an authenticator app like Google Authenticator Microsoft Authenticator,
        or Authy.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Trading Policies and Fees</h3>
      </p>
      <p>
        <strong>29. What are the trading fees on MusicBull?&nbsp;</strong>
      </p>
      <p>
        Answer: Trading fees are applied per transaction and may vary based on
        your trading volume or membership level. Refer to our Fee Schedule for
        detailed information.
      </p>
      <p>
        <strong>30. Are there any inactivity fees?</strong>
      </p>
      <p>
        Answer: No, MusicBull does not charge inactivity fees. However, we
        encourage regular account activity to stay updated with platform changes
        and opportunities.
      </p>
      <p>
        <strong>31. Can I short-sell units on MusicBull?&nbsp;</strong>
      </p>
      <p>
        Answer: MusicBull does not support short-selling. You can only sell
        units that you own in your portfolio.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Portfolio Management</h3>
      </p>
      <p>
        <strong>
          32. How can I view the performance of my investments?&nbsp;
        </strong>
      </p>
      <p>
        Answer: In your &quot;Portfolio&quot; section, you can see detailed
        performance metrics, including current value, purchase price, unrealized
        gains/losses, and historical returns.
      </p>
      <p>
        <strong>33. Can I export my trading and transaction data?&nbsp;</strong>
      </p>
      <p>
        Answer: Yes, you can export your trading transaction history and account
        statements in CSV or PDF formats. Go to the &ldquo;Account&rdquo;
        section and click &quot;Reports&quot;, click on the report you wish, and
        then the Export button
      </p>
      <p>
        <strong>
          34. Does MusicBull offer any tools for portfolio analysis?&nbsp;
        </strong>
      </p>
      <p>
        Answer: MusicBull provides various tools, such as charts, performance
        analytics, and market news, to help you analyze and manage your
        investments effectively.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Regulatory and Legal</h3>
      </p>
      <p>
        <strong>35. Is MusicBull regulated, and are my funds safe?</strong>
      </p>
      <p>
        Answer: MusicBull complies with all applicable laws and regulations in
        the jurisdictions where it operates. Client funds are held in segregated
        accounts with reputable financial institutions.
      </p>
      <p>
        <strong>
          36. What are the tax implications of my trading activities?&nbsp;
        </strong>
      </p>
      <p>
        Answer: Tax obligations depend on your country of residence and local
        laws. MusicBull does not provide tax advice. We recommend consulting a
        tax professional to understand your responsibilities.
      </p>
      <p>
        <strong>
          37. How does MusicBull handle disputes or complaints?&nbsp;
        </strong>
      </p>
      <p>
        Answer: If you have a dispute or complaint, please contact our customer
        support team via our online form https://musicbull.com/contact-us/ or
        email us directly at{" "}
        <LinkStyled href="mailto:Contact@MusicBull.com" role="link">
          Contact@MusicBull.com
        </LinkStyled>
        . We are committed to resolving issues promptly and fairly.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Additional Support</h3>
      </p>
      <p>
        <strong>38. How can I contact customer support?</strong>
      </p>
      <p>
        Answer: You can reach our customer support via: - Email:{" "}
        <LinkStyled href="mailto:Contact@MusicBull.com" role="link">
          Contact@MusicBull.com
        </LinkStyled>
      </p>
      <p>
        <strong>
          39. Does MusicBull offer educational resources for traders?&nbsp;
        </strong>
      </p>
      <p>
        Answer: Yes, we offer a range of educational materials, including
        tutorials and articles.
      </p>
      <p>
        <strong>40. How do I update my personal information?</strong>
      </p>
      <p>
        Answer: Go to &quot;Account,&quot; select &quot;Profile,&quot; and you
        can update your address and other personal details. Some changes may
        require re-verification.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Common Issues</h3>
      </p>
      <p>
        <strong>
          41. My deposit hasn&rsquo;t appeared yet&mdash;what should I do?
        </strong>
      </p>
      <p>
        Answer: If the expected deposit time has passed, check if the funds were
        debited from your payment method. If so, please contact customer support
        via our online form https://musicbull.com/contact-us/ or email us
        directly at{" "}
        <LinkStyled href="mailto:Contact@MusicBull.com" role="link">
          Contact@MusicBull.com
        </LinkStyled>
        with the transaction details for assistance.
      </p>
      <p>
        <strong>
          42. I received an error message saying &ldquo;Insufficient
          Funds&rdquo; when placing an order. Why?
        </strong>
      </p>
      <p>
        Answer: This error occurs when your available cash balance is lower than
        the total cost of the order, including any fees. Check your cash balance
        and consider depositing additional funds or reducing the order size.
      </p>
      <p>
        <strong>43. How do I close my MusicBull account?</strong>
      </p>
      <p>
        Answer: If you wish to close your account, please withdraw any remaining
        funds and contact customer support via our online form
        https://musicbull.com/contact-us/ or email us directly at{" "}
        <LinkStyled href="mailto:Contact@MusicBull.com" role="link">
          Contact@MusicBull.com
        </LinkStyled>
        &nbsp;request. We&rsquo;ll guide you through the closure process.
      </p>
      <p>
        <strong>44. Can I have multiple accounts on MusicBull?</strong>
      </p>
      <p>
        Answer: No, users are permitted to have only one account to maintain
        compliance and security standards. Multiple accounts may be subject to
        suspension.
      </p>
      <p>
        <strong>45. How do I place a limit order?</strong>
      </p>
      <p>
        Answer: To place a limit order, navigate to the &quot;Trading
        Board&quot; and choose the asset. Select &ldquo;Trade&rdquo;, choose
        &quot;Buy or &ldquo;Sell&rdquo; with &nbsp;&quot;Limit Order&quot; and
        then enter the price and the number of units you wish to trade. Confirm
        the order, and it will remain open until the specified time or until it
        is filled.
      </p>
      <p>
        <strong>
          46. How do I track the order book for a specific symbol?
        </strong>
      </p>
      <p>
        Answer: Navigate to the trading board, click the &ldquo;Trade&rdquo;
        button, and then click the &ldquo;Advanced Trade&rdquo; link where you
        can view the advanced screen with the &nbsp; &nbsp;&quot;Order
        Book&quot; tab within the trading interface for a specific symbol. Here,
        you will be able to see real-time buy and sell orders, the bid-ask
        spread, volumes, and much more. &nbsp; Use this information to make
        informed trading decisions.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Portfolio and Investment Management</h3>
      </p>
      <p>
        <strong>47. How can I view my portfolio performance over time?</strong>
      </p>
      <p>
        Answer: In your &ldquo;Account&rdquo; click on &ldquo;Reports&rdquo;
        where you can view your portfolio performance over time. &nbsp;&nbsp;
      </p>
      <p>
        <strong>
          48. Can I receive notifications when my portfolio changes in value?
        </strong>
      </p>
      <p>
        Answer: We currently don&apos;t offer it. It will be available in our
        future release under &quot;Settings,&quot; then
        &quot;Notifications,&quot;
      </p>
      <p>
        <strong>49. How do I manage my risk exposure on the platform?</strong>
      </p>
      <p>
        Answer: Diversify your investments across different assets. Use
        stop-limit orders and regularly review your portfolio to adjust your
        risk based on market performance.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Secondary Market and Liquidity</h3>
      </p>
      <p>
        <strong>
          50. What is the liquidity of my units on the secondary market?
        </strong>
      </p>
      <p>
        Answer: Liquidity in the secondary market depends on market demand for a
        particular unit. The more popular the song or catalog, the more likely
        it is that other investors will want to trade units. You can always
        check the current market depth and trading volume for a symbol on the
        advanced trading screen to assess liquidity.
      </p>
      <p>
        <strong>51. How do I sell units on the secondary market?</strong>
      </p>
      <p>
        Answer: To sell units, navigate to &ldquo;My Portfolio&rdquo;, click
        &ldquo;Owned Units&rdquo;, find the symbol you want to sell, and select
        &ldquo;Trade&rdquo; where you can place a &quot;Sell&quot; order.
        &nbsp;Input the number of units and your desired price. You can place a
        market order or a limit order, depending on how quickly you want to
        sell.
      </p>
      <p>
        <strong>
          52. Can I trade units I bought in an auction immediately on the
          secondary market?
        </strong>
      </p>
      <p>
        Answer: Yes, after an auction closes and you have successfully acquired
        units, you can trade them on the secondary market.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Royalty Payments and Distribution</h3>
      </p>
      <p>
        <strong>53. How are royalties distributed to investors?</strong>
      </p>
      <p>
        Answer: Royalties are distributed on a semi-annual, quarterly, or
        monthly basis, depending on the specific terms of the symbol. Once the
        royalty payments are received by MusicBull, they are allocated to
        investors&apos; accounts proportionally based on the number of units
        held at the cutoff date.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Fees and Taxes</h3>
      </p>
      <p>
        <strong>54. Are there any hidden fees for trading on MusicBull?</strong>
      </p>
      <p>
        Answer: No, all fees are transparent and disclosed upfront. You can view
        the full fee schedule in the &quot;Fees&quot; section of our website.
        Typical fees include trading commissions and withdrawal fees.
      </p>
      <p>
        <strong>55. How does MusicBull handle withholding tax?</strong>
      </p>
      <p>
        Answer: MusicBull does not withhold taxes. It&apos;s the responsibility
        of each investor to report their income and consult a tax professional
        for guidance.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Advanced Functionality</h3>
      </p>
      <p>
        <strong>56. How do I participate in a new auction?</strong>
      </p>
      <p>
        Answer: To participate in a new auction, visit the &quot;Auction
        Board,&quot; browse through the available symbols, and place a bid on
        the auction of your choice. You can track the progress of the auction
        and adjust your bid as needed.
      </p>
      <p>
        <strong>57. How do I know if I won an auction?</strong>
      </p>
      <p>
        Answer: After the auction ends, you will receive a notification in your
        account if your bid was successful. The units you won will be added to
        your portfolio, and the funds will be deducted from your cash balance.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>Security and Compliance &nbsp;&nbsp;</h3>
        &nbsp;
      </p>
      <p>
        <strong>58. How does MusicBull protect my personal information?</strong>
      </p>
      <p>
        Answer: MusicBull uses advanced encryption technology and complies with
        strict data protection regulations to ensure your personal information
        is secure. We follow industry best practices for cybersecurity and data
        management.
      </p>
      <p>
        <strong>59. How do I report suspicious activity or fraud?</strong>
      </p>
      <p>
        Answer: If you notice any suspicious activity on your account, please
        report it immediately by contacting customer support via our online form
        https://musicbull.com/contact-us/ or email us directly at{" "}
        <LinkStyled href="mailto:Contact@MusicBull.com" role="link">
          Contact@MusicBull.com
        </LinkStyled>
        . You can also freeze your account temporarily for security reasons.
      </p>
      <p>
        <strong>
          60. Can I enable two-factor authentication (2FA) for additional
          security?
        </strong>
      </p>
      <p>
        Answer: Yes, we strongly recommend enabling 2FA to protect your account.
        You can do this by navigating to &quot;Account&quot; and selecting
        &quot;Enable 2FA&quot;.
      </p>
      <p>&nbsp;</p>
      <p>
        <h3>FAQ for issuers&nbsp;</h3>
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          61. How do I list my catalog or song for auction on MusicBull?
        </strong>
      </p>
      <p>
        Answer: To list a song or catalog, go to the &apos;Issuer
        Dashboard&apos; and select &apos;Create Auction.&apos; You&rsquo;ll need
        to provide song details, ownership documentation, royalty data, and
        choose the percentage of royalties you want to auction.
      </p>
      <p>
        <strong>
          62. What documentation do I need to prove ownership of my music?
        </strong>
      </p>
      <p>
        Answer: Issuers are required to submit ownership documentation such as
        publishing agreements, ISWC and ISRC codes, and collection society
        affiliations (e.g., ASCAP, BMI) to validate their rights to the
        royalties being auctioned.
      </p>
      <p>
        <strong>63. What is an ISRC code?</strong>
      </p>
      <p>
        The ISRC code (International Standard Recording Code) is a unique
        identifier assigned to individual sound recordings and music videos.
        This code serves as a digital fingerprint for each recording, allowing
        for accurate tracking, identification, and management of royalties
        across different platforms and markets.
      </p>
      <p>
        <strong>64. What is ISWC code?</strong>
      </p>
      <p>
        The ISWC code (International Standard Musical Work Code) is a unique
        identifier for musical works (compositions) rather than sound
        recordings. It helps in tracking and managing royalties specifically for
        the composition rights, which include lyrics and musical arrangements,
        across different platforms and regions.
      </p>
      <p>
        <strong>65. What is an IPI number, and why do I need it?</strong>
      </p>
      <p>
        Answer: The IPI (Interested Parties Information) number is a unique
        identifier assigned to songwriters and composers by Performing Rights
        Organizations (PROs) to track royalties. It helps MusicBull verify your
        rights and process your auction accurately.
      </p>
      <p>
        <strong>
          66. How do I calculate the percentage of royalties to auction?
        </strong>
      </p>
      <p>
        Answer: Consider your financial goals and the historical earnings of
        your catalog. You may also use MusicBull&apos;s benchmark prcing
        indications during the online listing process for guidance on setting
        realistic auction percentages based on market trends.
      </p>
      <p>
        <strong>
          67. How often will I receive funds after an auction closes?
        </strong>
      </p>
      <p>
        Answer: Funds from auction proceeds are typically available after the
        auction&rsquo;s settlement period, which can take a few business days.
        Royalties earned from sold units will be distributed according to the
        royalty payment schedule you set (monthly , quarterly, semi-annually or
        annually ).
      </p>
      <p>
        <strong>
          68. What happens if my auction doesn&rsquo;t meet the target price?
        </strong>
      </p>
      <p>
        Answer: If the target price isn&rsquo;t met, you have the options 1.
        Extend the auction time or 2. Accept the price achieved. Alternatively,
        you can cancel the auction and relaunch it at a later date.
      </p>
      <p>
        <strong>69. How do I market my auction to potential investors?</strong>
      </p>
      <p>
        Answer: MusicBull offers tools to help you promote your auction,
        including personalized video uploads, social media integrations, and
        featured listings. Engaging with your fanbase can drive interest and
        raise bid prices.
      </p>
      <p>
        <strong>70. Can I retain full control of my master rights?</strong>
      </p>
      <p>
        Answer: Yes, MusicBull allows issuers to sell only future royalties
        while retaining 100% control of their master rights, ensuring you
        maintain creative control over your work.
      </p>
      <p>
        <strong>71. What fees are associated with listing an auction?</strong>
      </p>
      <p>
        Answer:
        <span>
          MusicBull charges a listing fee for setting up an auction, as well as
          a small percentage on successful transactions. Details can be found in
          our &apos;
        </span>{" "}<LinkStyled href="https://musicbull.com/auction-exchange-fees/">Fees Schedule</LinkStyled>{" "}
        <span> &apos; section.& </span>
      </p>
      <p>
        <strong>
          72. Can I auction royalties from multiple revenue streams (e.g.,
          streaming, sync)?
        </strong>
      </p>
      <p>
        Answer: Yes, you can auction royalties from various sources, such as
        streaming, sync, mechanical, and public performance. Specify the streams
        included in the auction to provide transparency for investors.
      </p>
      <p>
        <strong>
          73. What&rsquo;s the difference between a public and a private
          auction?
        </strong>
      </p>
      <p>
        Answer: Public auctions are open to all investors, maximizing exposure
        and competition. Private auctions, however, allow you to select specific
        audiences (e.g., superfans) and limit participation, creating an
        exclusive investment opportunity.
      </p>
      <p>
        <strong>
          74. How do I monitor the performance of my auction while it&rsquo;s
          live?
        </strong>
      </p>
      <p>
        Answer: You can track bids, view real-time price changes, through the
        &apos;Auction Dashboard,&apos; which provides detailed analytics on
        auction activity.
      </p>
      <p>
        <strong>75. What happens to unsold units aft`er an auction?</strong>
      </p>
      <p>
        Answer: Unsold units are retaine`d by you in your portfolio as units
        that are available for secondary trading or re-auction in a future
        auction - we named the units &nbsp; &ldquo;My Units&rdquo; where you can
        see their current market value based on the market price. MusicBull
        provides flexibility in managing unsold &ldquo;Units&rdquo; (&ldquo;My
        units&rdquo;) to maximize your catalog&rsquo;s long-term value.
      </p>
      <p>
        <strong>
          76. Can I launch additional auctions after my first one?
        </strong>
      </p>
      <p>
        Answer: Yes, you can launch multiple auctions over time, allowing you to
        strategically sell portions of your royalties as demand and market
        conditions evolve.
      </p>
      <p>
        <strong>
          77. How will my royalties be distributed to investors on MusicBull?
        </strong>
      </p>
      <p>
        Answer: Royalties collected from various revenue streams are directed to
        MusicBull&rsquo;s custodian account and allocated to investors based on
        their proportional holdings in your auctioned units.
      </p>
      <p>
        <strong>
          78. What types of media should I upload to my auction page?
        </strong>
      </p>
      <p>
        Answer: We recommend high-quality images (album covers, artist photos),
        videos (e.g., interviews or performances), and royalty data to make your
        auction page visually appealing and informative.
      </p>
      <p>
        <strong>
          79. Can I withdraw unsold units from MusicBull&rsquo;s platform?
        </strong>
      </p>
      <p>
        Answer: Yes, unsold units remain under your ownership, and you have the
        flexibility to retain, relist, or sell them as you choose.
      </p>
    </SupportCenterContainer>
  );
};

export default SupportCenter;
